import * as z$1 from "zod/v4";
/**
* Canonical catch-up response shape across Core/Gateway/CLI.
* `nextCursor` is nullable; invalid cursor types fail fast.
*/
const catchupResponseSchema = z$1.strictObject({
	signals: z$1.array(z$1.unknown()),
	nextCursor: z$1.union([z$1.string().refine((value) => value.trim().length > 0), z$1.null()]).optional()
}).transform((value) => {
	const nextCursor = value.nextCursor ?? null;
	return {
		signals: value.signals,
		nextCursor
	};
});
//#endregion
export { catchupResponseSchema };

//# sourceMappingURL=catchup-response.js.map